import { createAsyncThunk } from '@reduxjs/toolkit';
import { fixPhoneFormat } from 'services/common/common.service';
import { ICommonResponse } from 'services/types';

export const ThunkBeautifyPhoneNumber = createAsyncThunk<ICommonResponse<string>, string>(
  'common/getAppLogo',
  phone => fixPhoneFormat(phone).then(r => r.data),
);
